export const headerContainerSx = {
  backgroundColor: 'rgb(21, 101, 192)',
  color: '#fff',
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  zIndex: 3,

  h3: {
    fontWeight: 500,
    fontSize: '1rem',
    fontFamily: "'PT Root UI',sans-serif",
  },
}

export const contentTitleSx = {
  background: 'rgba(237, 241, 245, 1)',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px 48px 8px 16px',
  border: 'solid 1px rgba(165, 165, 165, 1)',
  fontWeight: '500',
  fontSize: '15px',
  marginLeft: '-16px!important',
  marginRight: '-16px!important',
}

export const contentWrapperSx = {
  padding: '68px 0 40px 0',
  overflowY: 'auto',
  minHeight: '100%',
}

export const searchResultTitleSx = {
  marginBottom: '14px !important',
  marginLeft: '0 !important',
  maxWidth: '100%',
}

export const searchResWarningSx = {
  marginTop: '0!important',
  marginBottom: '14px!important',
  paddingX: '16px',
}

export const notFoundResultsWrapper = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0 25px',
  marginTop: '0 !important',
}
